var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1857 10.0843C27.0014 10.0886 27.7821 10.4168 28.3559 10.9966C28.9297 11.5764 29.2498 12.3603 29.2457 13.1761C31.0082 14.0204 32.5077 15.3284 33.5834 16.96C34.6591 18.5916 35.2705 20.4852 35.352 22.4378L35.326 27.0517C35.4368 28.0087 35.7708 28.9263 36.3012 29.7307C36.8315 30.535 37.5432 31.2036 38.3792 31.6825L13.7707 31.5565C14.6112 31.0861 15.3296 30.4251 15.868 29.6265C16.4064 28.8279 16.7497 27.914 16.8705 26.9585L16.8922 22.3424C16.9938 20.3908 17.6248 18.5036 18.7173 16.8832C19.8098 15.2628 21.3227 13.9703 23.0939 13.1443C23.0982 12.3285 23.4264 11.5479 24.0062 10.9741C24.586 10.4002 25.3699 10.0802 26.1857 10.0843Z",
    stroke: "#3152E7",
    strokeWidth: 1.15934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4622 31.5947L21.4543 33.1326C21.4479 34.3566 21.9281 35.533 22.7891 36.4029C23.6501 37.2728 24.8214 37.7651 26.0454 37.7715C27.2693 37.7778 28.4457 37.2976 29.3156 36.4366C30.1856 35.5756 30.6779 34.4043 30.6842 33.1803L30.6921 31.6424",
    stroke: "#3152E7",
    strokeWidth: 1.15934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanNotificationIcon);
export default __webpack_public_path__ + "static/media/plan-notification-icon.3ec7772b6da42d415155cc6b8889dbdd.svg";
export { ForwardRef as ReactComponent };